import * as _ from "lodash"


export interface IContinueConditionState<GroupContext> {
    GroupContext: GroupContext,
    WaiterContext: any,
}

interface DeferPromise {
    resolve(): void
    error(e: any): void
}

interface Waiter<GrpContext> {
    WaiterId: number
    WaiterContext: any
    ContinueCondition?: (a: IContinueConditionState<GrpContext>) => boolean | Promise<boolean>
    WaitCount: number,
    DeferPromise: DeferPromise
    PromiseResults: any,
    bDone: boolean,
    Error?: any,
    ErrorCount?: number
}

export class WaitForGroup<Context> {

    private grpContext: Context
    private waiterIdSequence: number
    private waiters: Waiter<Context>[]

    constructor(GroupContext: Context) {
        this.waiterIdSequence = 0
        this.waiters = []
        this.grpContext = GroupContext
    }

    checkContinueConditions(): void {
        const self = this

        let waitFunctions: Promise<any>[] = []

        for(let aWaiter of this.waiters){
            if(aWaiter.bDone)
                continue

            aWaiter.WaitCount += 1

            if(!_.isFunction(aWaiter.ContinueCondition)){
                aWaiter.bDone = true
                aWaiter.DeferPromise.resolve()
                continue
            }

            let continueCondRslts = aWaiter.ContinueCondition({WaiterContext: aWaiter.WaiterContext, GroupContext: this.grpContext})

            if(_.isBoolean(continueCondRslts)){
                if(continueCondRslts){
                    aWaiter.bDone = true
                    aWaiter.DeferPromise.resolve()
                }
                continue
            }

            if (_.isFunction(continueCondRslts?.then)) {
                waitFunctions.push(
                    continueCondRslts
                        .then((res) => {
                            if (res)
                                aWaiter.bDone = true
                        })
                        .catch((e) => { //--
                            aWaiter.Error = e
                            aWaiter.ErrorCount = 1 + (aWaiter.ErrorCount || 0)
                            if(aWaiter.ErrorCount > 5)
                                aWaiter.bDone = true
                        }))
                continue
            }
            // If we reached here, we didn't understand the condition return value
            //aWaiter.bDone = true
        } // Next Waiter

        if(waitFunctions.length)
            Promise.all(waitFunctions)
                .finally(() => {
                    _.remove(self.waiters, (a) => a.bDone)
                })
        else
            _.remove(self.waiters, (a) => a.bDone)

    }

    waitFor(ctx: any,
            continueCondition?: (a: IContinueConditionState<Context>) => boolean | Promise<boolean>,
            waitPromiseResult?: any): Promise<any>
    {
        let dp = this.createDeferPromise(waitPromiseResult)
        this.waiters.push({
            WaiterId: this.waiterIdSequence++,
            WaitCount: 0,
            WaiterContext: ctx,
            ContinueCondition: continueCondition,
            DeferPromise: dp,
            PromiseResults: waitPromiseResult,
            bDone: false
        })
        return dp
    }

    private createDeferPromise(results: any): Promise<any> & DeferPromise {
        var res: any, err: any
        let rv: Promise<any> & DeferPromise = <any> new Promise((resolve, error) => {
            res = resolve
            err = error
        })
        rv.resolve = ()=> {res(results)}
        rv.error = (e: any)=> { err(e)}
        return rv
    }

}

